<ngb-carousel
  [showNavigationArrows]="true"
  [showNavigationIndicators]="false"
  [interval]="5000"
  [animation]="false"
  class="container my-5 carousel-container"
>
  <ng-template ngbSlide>
    <app-nmm-slide></app-nmm-slide>
  </ng-template>
  <ng-template ngbSlide>
    <app-dowload-app-slide></app-dowload-app-slide>
  </ng-template>
  <ng-template ngbSlide>
    <app-recommended-app-slide></app-recommended-app-slide>
  </ng-template>
  <ng-template ngbSlide>
    <app-made-it-home-safely-slide></app-made-it-home-safely-slide>
  </ng-template>
</ngb-carousel>
